var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_radial_5150_7255)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0539 10.0469C14.418 10.0469 10.0479 14.1769 10.0479 19.7527C10.0479 22.6694 11.2436 25.191 13.1897 26.932C13.3523 27.0771 13.4524 27.2822 13.4574 27.5023L13.5124 29.2834C13.5164 29.4145 13.5526 29.5425 13.6177 29.6563C13.6827 29.7701 13.7748 29.8662 13.8857 29.9361C13.9966 30.006 14.123 30.0476 14.2538 30.0573C14.3845 30.0669 14.5156 30.0442 14.6356 29.9913L16.6218 29.1158C16.7894 29.0408 16.9795 29.0283 17.1571 29.0758C18.0702 29.3259 19.0407 29.461 20.0539 29.461C25.6897 29.461 30.0599 25.331 30.0599 19.7552C30.0599 14.1794 25.6897 10.0469 20.0539 10.0469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0452 22.5919L16.9845 17.9291C17.0951 17.7535 17.2408 17.6028 17.4126 17.4865C17.5844 17.3701 17.7784 17.2906 17.9824 17.253C18.1865 17.2154 18.3961 17.2205 18.598 17.2679C18.8 17.3154 18.9899 17.4043 19.1558 17.5289L21.4947 19.2824C21.5991 19.3606 21.7262 19.4026 21.8566 19.4022C21.987 19.4017 22.1138 19.3588 22.2176 19.2799L25.3745 16.8835C25.7948 16.5633 26.3451 17.0686 26.065 17.5164L23.1232 22.1766C23.0126 22.3522 22.8669 22.5029 22.6951 22.6193C22.5233 22.7357 22.3293 22.8152 22.1253 22.8528C21.9213 22.8904 21.7116 22.8853 21.5097 22.8378C21.3077 22.7903 21.1178 22.7015 20.9519 22.5769L18.613 20.8233C18.5086 20.7452 18.3815 20.7031 18.2511 20.7036C18.1207 20.704 17.9939 20.7469 17.8901 20.8258L14.7332 23.2223C14.3129 23.5425 13.7626 23.0397 14.0452 22.5919Z",
    fill: "url(#paint1_radial_5150_7255)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5150_7255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.7 39.9989) scale(44 43.9988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5150_7255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3999 30.0589) scale(22.0132 22.0132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/Messenger.f900820378dffaa1a6dcba85543c90a0.svg";
export { ForwardRef as ReactComponent };